import React, { useState, useRef } from 'react';

const CardHeader = ({ title, subtitle, icon: Icon, colorClass }) => (
  <div className="flex items-center justify-between mb-6">
    <div>
      <h3 className="text-xl font-bold text-slate-900">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {Icon && (
      <div className={`p-2.5 rounded-xl ${colorClass}`}>
        <Icon size={20} strokeWidth={2.5} />
      </div>
    )}
  </div>
);
export default CardHeader;